module.exports = "/_next/static/images/1b74cac440b729e4d11b57a29f79f468-boy-looking-to-the-front-lg@2x.jpg";